import { render, staticRenderFns } from "./TheMenuSublevel.vue?vue&type=template&id=6f3a6806&"
import script from "./TheMenuSublevel.vue?vue&type=script&lang=js&"
export * from "./TheMenuSublevel.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuSublevel.vue?vue&type=style&index=0&id=6f3a6806&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports